import type { ContractAppProfileDto } from "src/app/features/Contract/types/subTypes/ContractAppProfileDto";
import { AcceptMode } from "src/app/features/Contract/types/subTypes/ContractAppProfileEntity";
import type { ContractProfileDto } from "../../types/ContractProfileDto";
import type { ContractProfileEntity } from "../../types/ContractProfileEntity";

export const ContractProfileEntityToDto = ({ acceptedCardProfiles, ...rest }: Readonly<ContractProfileEntity>): ContractProfileDto => {
    const newContractAppProfiles: ContractAppProfileDto[] =
        acceptedCardProfiles?.map(({ acceptMode, ...contractAppProfile }) => {
            const degraded = acceptMode === AcceptMode.DEGRADED.value;
            const offline = acceptMode === AcceptMode.OFFLINE.value || degraded;
            const online = acceptMode === AcceptMode.ONLINE.value || offline || degraded;

            return { ...contractAppProfile, online, offline, degraded };
        }) || [];

    return { ...rest, acceptedCardProfiles: newContractAppProfiles };
};
